import { getTimezone } from '@urc-ui/services/app-context';

export const resolveAdvertisingApiBaseUrl = () => {
  const appContext = window.AppContext;
  const defaultApiUrl = 'https://advertising.integ.amazon.com/a9g-api-gateway';
  const path = (appContext?.advertisingApiEndpoint as string) || '';

  // if path is falsy, OR if the current origin contains a port number (i.e. presumed to be served from local dev server), return default
  if (!path || window.location.port) {
    return defaultApiUrl;
  }

  const origin = window.location.origin.includes('advertising-preprod')
    ? window.location.origin.replace('advertising-preprod', 'advertising')
    : window.location.origin;

  // if path is truthy but is not a complete URL (i.e. does not start with protocol 'http'), prepend current origin
  if (!path.startsWith('http')) {
    return `${origin}${path}`;
  }
  return path;
};

export const getAdvertisingApiHeaders = () => {
  const appContext = window.AppContext;
  return {
    'amazon-advertising-api-advertiserid': appContext.entityId as string,
    'amazon-advertising-api-clientid': appContext.advertisingApiClientId as string,
    'amazon-advertising-api-csrf-data': appContext.advertisingApiClientId as string,
    'amazon-advertising-api-marketplaceid': appContext.marketplaceId as string,
    'amazon-advertising-api-csrf-token': appContext.advertisingApiCsrfToken as string,
    'x-use-obfuscated-ids': true as boolean,
    'amazon-advertising-api-isimpersonator': (appContext.isSpoofer === 'true') as boolean,
    'amazon-advertising-api-isportalserver': window.isMidwayAuthenticated as boolean,
    ...(!!appContext.globalAccountId && {
      'Amazon-Ads-GlobalAccountId': appContext.globalAccountId as string
    })
  };
};

export const getLocaleheader = () => {
  const appContext = window.AppContext;
  return {
    locale: (appContext.locale as string)?.replace('_', '')
  };
};

export const getAcceptLanguageHeader = () => {
  const appContext = window.AppContext;
  return {
    'accept-language': (appContext.locale as string)?.replace('_', '-') ?? 'en-US'
  };
};

export const getTimezoneHeader = () => {
  return {
    timeZone: getTimezone()
  };
};

export const getMarketplaceIdHeader = () => {
  const appContext = window.AppContext;
  return {
    selectedEntityMarketplaceId: appContext.marketplaceId as string
  };
};
